module.exports = __webpack_public_path__ + "static/3-58f617929f2cc2492b5df81349aaeece.png";